import axios from '../lib/axios';
import { constants } from './constants';

export const sendClientError = async (message) => {
  axios.post(`${constants?.api?.url_new}/report/clientError`, { message }).catch((err) => {
    console.log('error: ', err);
  });
};
